"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomers = void 0;
var getCustomers_1 = __importDefault(require("./getCustomers"));
exports.getCustomers = getCustomers_1.default;
